import { createContext } from 'react';

export const FileContext = createContext();
